export default __webpack_public_path__ + "static/media/TableIcon .761bd3b0.svg";